import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const PRODUCTS = [
  { name: 'Bosakitug (ATI-045)', link: 'https://www.aclaristx.com/investigational-drug-candidates/#ati-045', image: '/images/aclaris/bosakitug.png' },
  { name: 'ATI-2138', link: 'https://www.aclaristx.com/investigational-drug-candidates/#ati-2138', image: '/images/aclaris/ati-2138.png' },
  { name: 'ATI-052', link: 'https://www.aclaristx.com/investigational-drug-candidates/#ati-052', image: '/images/aclaris/ati-052.png' },
  { name: 'Lepzacitinib (ATI-1777)', link: 'https://www.aclaristx.com/investigational-drug-candidates/#ati-1777', image: '/images/aclaris/lepzacitinib.png' },
  { name: 'Zunsemetinib (ATI-450)', link: 'https://www.aclaristx.com/investigational-drug-candidates/#ati-450', image: '/images/aclaris/zunsemetinib.png' },
  { name: 'Aclaris Photon 360 Hydra Sunscreen Fluid Cream SPF 50+', link: 'https://Revive.com/collections/aclaris', image: '/images/aclaris/aclaris-photon-360-matte.webp' },
  { name: 'Aclaris Photon 360 Matte Sunscreen Gel SPF 50+ PA+++', link: 'https://Revive.com/collections/aclaris', image: '/images/aclaris/aclaris-photon-360-matte.webp', images: ['/images/aclaris/aclaris-photon-360-matte-1.webp','/images/aclaris/aclaris-photon-360-matte-2.avif','/images/aclaris/aclaris-photon-360-matte-3.webp'] }
]

export default function Aclaris(){
  const [galleryOpen, setGalleryOpen] = useState(false)
  const [galleryImages, setGalleryImages] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    function onKey(e){
      if(!galleryOpen) return
      if(e.key === 'ArrowRight') setCurrentIndex(i => Math.min(i + 1, galleryImages.length - 1))
      if(e.key === 'ArrowLeft') setCurrentIndex(i => Math.max(i - 1, 0))
      if(e.key === 'Escape') setGalleryOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [galleryOpen, galleryImages])

  function openGallery(images, start = 0){
    setGalleryImages(images)
    setCurrentIndex(start)
    setGalleryOpen(true)
  }

  function closeGallery(){
    setGalleryOpen(false)
    setGalleryImages([])
    setCurrentIndex(0)
  }

  return (
    <section className="py-12">
      <div className="container-custom mx-auto px-6">
        <h2 className="text-2xl font-bold mb-4">ACLARIS</h2>
        <p className="mb-6 text-sm text-gray-600">Aclaris Therapeutics investigational drug candidates and pipeline links.</p>

        <ul className="grid md:grid-cols-1 gap-4">
          {PRODUCTS.map(p => (
            <li key={p.name} onClick={() => p.images ? openGallery(p.images,0) : window.open(p.link, '_blank')} className="p-4 bg-white rounded shadow-sm flex items-start gap-4 cursor-pointer hover:shadow-md transition">
              <img src={p.image} alt={p.name} loading="lazy" className="w-28 h-28 object-cover rounded" />
              <div className="flex-1">
                <div className="font-semibold">{p.name}</div>
              </div>
            </li>
          ))}
        </ul>

        <div className="mt-6">
          <Link to="/brands" className="text-brand">Back to Brands</Link>
        </div>

        {galleryOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70" onClick={closeGallery}>
            <div className="relative max-w-5xl w-full mx-4" onClick={e => e.stopPropagation()}>
              <button onClick={closeGallery} className="absolute right-0 top-0 m-2 text-white bg-black/30 rounded px-2 py-1">Close</button>
              <div className="bg-white rounded overflow-hidden">
                <div className="flex flex-col md:flex-row">
                  <div className="w-full md:w-24 p-3 bg-white border-r overflow-y-auto">
                    <ul className="flex md:flex-col gap-3">
                      {galleryImages.map((src, idx) => (
                        <li key={src} className={`cursor-pointer p-1 rounded border ${idx === currentIndex ? 'ring-2 ring-offset-1 ring-brand' : 'border-transparent'}`} onClick={() => setCurrentIndex(idx)}>
                          <img src={src} alt={`thumb-${idx+1}`} className="w-16 h-16 object-cover rounded" />
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="flex-1 p-4 flex flex-col items-center justify-center bg-white">
                    <div className="w-full flex items-center justify-center relative">
                      <button onClick={() => setCurrentIndex(i => Math.max(i - 1, 0))} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/20 text-white rounded-full p-2">‹</button>
                      <img src={galleryImages[currentIndex]} alt={`photo-${currentIndex+1}`} className="max-h-[70vh] object-contain" />
                      <button onClick={() => setCurrentIndex(i => Math.min(i + 1, galleryImages.length - 1))} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/20 text-white rounded-full p-2">›</button>
                    </div>
                    <div className="mt-3 text-sm text-gray-600">{currentIndex + 1} / {galleryImages.length}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </section>
  )
}
